import React, {Component, Fragment} from 'react';
import './App.css';
import Election from "./Election";
import axios from "axios";
import Footer from "./Footer";
import Header from "./Header";
import LoadingSpinner from "./LoadingSpinner";


class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            client: null,
            rc: []
        };
    }

    componentDidMount() {

        this.lodBase(window.location.hostname);
    }


    lodBase = name => {
        this.setState({loading: true}, () => {
            axios({
                method: "get",
                url: "/data/prueba.json"
                //url: process.env.REACT_APP_BASE_URL + "/" + name + ".json"
            })
                .then(response => {

                    this.setState({loading: false, client: response.data});
                })
                .catch(error => {


                    this.setState({loading: false});
                })
        });
    };


    render() {

        return (
            <div className="container-fluid">
                <Header/>

                {this.state.loading ? (
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-11  text-center m-4 ">
                            <LoadingSpinner/>
                        </div>
                    </div>
                ) : (
                    <Fragment>
                        {this.state.client ? (
                            <Election election={this.state.client.elections[0]}/>
                        ) : (
                            <div className="row justify-content-center">
                                <div className="col-12 col-sm-11  text-center m-4 ">
                                    <h2 className="m-4">Lo sentimos, no pudimos encontrar la página, revise la
                                        dirección</h2>
                                </div>
                            </div>
                        )}
                    </Fragment>
                )}

                <Footer election={this.state.client ? this.state.client.elections[0] : null}/>
            </div>
        );
    }
}


export default App;